import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject } from '@angular/core';
import { WindowModule, WINDOW } from '@upr-web-primer/window';
import { get } from 'lodash-es';
import { BehaviorSubject, fromEvent, timer } from 'rxjs';
import { debounce, map } from 'rxjs/operators';

class ViewportModule {
}
ViewportModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ViewportModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ViewportModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ViewportModule, imports: [WindowModule] });
ViewportModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ViewportModule, imports: [[WindowModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ViewportModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [WindowModule]
                }]
        }] });

class ViewportService {
    constructor(window) {
        this.window = window;
        this.breakpoints = {
            a: 320,
            b: 480,
            c: 600,
            d: 768,
            e: 1024,
            f: 1200
        };
        const detectedViewport = this.detect();
        this.viewport$ = new BehaviorSubject(detectedViewport);
        this.viewport$.next(detectedViewport);
        fromEvent(this.window, 'resize')
            .pipe(debounce(() => timer(200)), map(event => this.detect(event)))
            .subscribe(viewportInfo => this.viewport$.next(viewportInfo));
    }
    detect(event) {
        const width = get(event, 'currentTarget.innerWidth') ||
            get(this.window, 'innerWidth'), height = get(event, 'currentTarget.innerHeight') ||
            get(this.window, 'innerHeight');
        let viewport = 'mobile';
        if (width > this.breakpoints.b && width < this.breakpoints.e) {
            viewport = 'tablet';
        }
        else if (width >= this.breakpoints.e) {
            viewport = 'desktop';
        }
        if (this.viewport !== viewport) {
            this.viewport = viewport;
        }
        const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        return { width, height, viewport, isMobileDevice };
    }
}
ViewportService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ViewportService, deps: [{ token: WINDOW }], target: i0.ɵɵFactoryTarget.Injectable });
ViewportService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ViewportService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ViewportService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }]; } });

export { ViewportModule, ViewportService };
